import * as React from 'react';

const PosterPersonImage = (props: { portrait: string }) => (
    <div className={`poster-image-container ${(!props.portrait || props.portrait === 'https://s3.us-east-2.amazonaws.com/caseview-children-assets/Images/no_photo_found.jpg') && 'd-none'}`}>
        <img className={'child-image'} src={props.portrait} />
    </div>
)

export default PosterPersonImage;